import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicManageAndSettingsIcon extends BaseIcon {
  getChildren = () => [
    <g>
		<g>
			<g>
				<rect x="13" y="19" fill={ this.getColor() } width="11" height="2"/>
			</g>
		</g>
		<g>
			<g>
				<rect y="19" fill={ this.getColor() } width="6" height="2"/>
			</g>
		</g>
		<path fill={ this.getColor() } d="M9.5,24L9.5,24c0.8,0,1.5-0.7,1.5-1.5v-4c0-0.8-0.7-1.5-1.5-1.5h0C8.7,17,8,17.7,8,18.5v4   C8,23.3,8.7,24,9.5,24z"/>
		<g>
			<g>
				<rect x="10" y="3" fill={ this.getColor() } width="14" height="2"/>
			</g>
		</g>
		<g>
			<g>
				<rect y="3" fill={ this.getColor() } width="3" height="2"/>
			</g>
		</g>
		<path fill={ this.getColor() } d="M6.5,8L6.5,8C7.3,8,8,7.3,8,6.5v-4C8,1.7,7.3,1,6.5,1h0C5.7,1,5,1.7,5,2.5v4C5,7.3,5.7,8,6.5,8z"/>
		<g>
			<g>
				<rect x="21" y="11" fill={ this.getColor() } width="3" height="2"/>
			</g>
		</g>
		<g>
			<g>
				<rect y="11" fill={ this.getColor() } width="14" height="2"/>
			</g>
		</g>
		<path fill={ this.getColor() } d="M17.5,16L17.5,16c0.8,0,1.5-0.7,1.5-1.5v-4C19,9.7,18.3,9,17.5,9h0C16.7,9,16,9.7,16,10.5v4   C16,15.3,16.7,16,17.5,16z"/>
	</g>
  ]
  getViewBox = () => '0 0 24 24'
}
